import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import styles from './VideoSecTime.module.less'

function VideoSecTime(props: { progress: number | undefined, duration: number }) {
  const { progress, duration } = props
  const [currentSecTime, setCurrentSecTime] = useState<string>('00:00')
  useEffect(() => {
    if (progress && progress) {
      const currentSecTime = (duration - 1) * progress / 100 + 1
      setCurrentSecTime(dayjs(currentSecTime * 1000).format('mm:ss'))
    } else {
      setCurrentSecTime('00:00')
    }
  }, [duration, progress])

  return <span className={styles.videoSecTime}>
    <span className={styles.time}>
      {currentSecTime}
    </span>
    <span className={styles.break}>/</span>
    <span className={styles.duration}>
      {dayjs(props.duration * 1000).format('mm:ss')}
    </span>
  </span>

}


export default VideoSecTime